import { useQuery } from '@tanstack/react-query';
import { fetchR2VisitClinicInvoiceList } from '@/services/main/visitClinicInvoice';
import { useClinicContext } from './useClinicContext';

/**
 * SCR-182 list for R2.
 *
 * Mirrors useContinuationList's contract — same params in, same `{ list }` out — so the
 * page can swap sources on serviceType without touching anything downstream.
 *
 * `searchNonce` changes on every 検索 press: BD §4 says 検索 always recalculates, so the
 * same criteria must not be served from cache (e.g. right after a 「済」 reset).
 */
export function useR2VisitClinicInvoiceList(
  params: Record<string, unknown> | null,
  searchNonce = 0
) {
  const { tenant, clinicNumber } = useClinicContext();
  const siteType = tenant;

  return useQuery({
    queryKey: ['visitClinicInvoice', 'r2-list', siteType, clinicNumber, params, searchNonce],
    queryFn: () => fetchR2VisitClinicInvoiceList(siteType ?? '', clinicNumber ?? '', params ?? {}),
    enabled: !!siteType && !!clinicNumber && params !== null && Object.keys(params).length > 0,
    staleTime: 30_000,
  });
}
